import { useMutation } from '@tanstack/react-query'
import { InvoiceFormValues } from 'app/components/InvoiceForm/schema'
import transformValuesToApi from 'app/components/InvoiceEdit/translators/transformFormValuesToAPI'
import { Invoice } from 'types/index'
import { useApi } from 'api'

const useUpdateInvoice = ({
  onSuccess,
  onError,
}: {
  onSuccess: (invoice: Invoice) => void
  onError?: (error: Error) => void
}) => {
  const client = useApi()

  const { mutate: updateInvoice, isPending } = useMutation({
    mutationFn: async ({
      invoice,
      data,
    }: {
      invoice: Invoice
      data: InvoiceFormValues
    }) => {
      const response = await client.putInvoice(
        { id: Number(invoice.id) },
        transformValuesToApi(invoice, data)
      )
      return response.data
    },
    onSuccess,
    onError,
  })

  return { updateInvoice, isPending }
}

export default useUpdateInvoice
